var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 812,
    height: 796,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: -109,
    width: 812,
    height: 796
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: -80,
    width: 813,
    height: 767
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: -80,
    width: 860,
    height: 806
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-96 109)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.768 444.44C562.086 444.44 528.297 478.23 528.297 519.911 528.297 561.593 562.086 595.383 603.768 595.383 645.45 595.383 679.239 561.593 679.239 519.911 679.197 478.247 645.432 444.482 603.768 444.44ZM603.768 578.611C571.349 578.611 545.069 552.331 545.069 519.911 545.069 487.493 571.349 461.212 603.768 461.212 636.187 461.212 662.468 487.493 662.468 519.911 662.468 552.331 636.187 578.611 603.768 578.611Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0662 0 0 1 75.8468 -79.6086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.914 503.283C292.944 508.766 293.475 514.332 293.498 519.911L293.498 520.054 511.576 520.054 511.576 519.911C511.6 514.332 512.13 508.766 513.161 503.283Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0662 0 0 1 75.8468 -79.6086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.625 368.969C724.675 368.969 754.71 399.004 754.71 436.055L754.71 486.503C754.71 495.766 747.202 503.274 737.939 503.274L694.443 503.274C695.468 508.761 695.993 514.33 696.011 519.911L696.011 520.054 737.939 520.054C756.439 519.995 771.422 505.012 771.482 486.511L771.482 436.197C771.352 389.882 733.856 352.359 687.541 352.198L618.024 352.198C609.112 352.485 600.526 348.839 594.544 342.228L488.885 237.407C476.195 224.809 458.964 217.856 441.086 218.12L302.194 218.12C302.085 218.12 301.993 218.061 301.884 218.061 301.775 218.061 301.691 218.12 301.582 218.12L195.386 218.12C177.538 218.019 160.368 224.947 147.588 237.407L43.6055 342.228C37.0858 348.629 33.4527 357.409 33.5427 366.546L33.5427 452.918C33.6623 489.919 63.6275 519.884 100.628 520.004L109.014 520.004 109.014 519.911C109.035 514.333 109.562 508.766 110.59 503.283L100.628 503.283C72.8404 503.283 50.314 480.756 50.314 452.969L50.314 368.969ZM477.094 249.289 580.808 352.198 310.27 352.198 310.27 234.857 441.086 234.857C454.549 234.583 467.547 239.792 477.094 249.289ZM159.462 249.239C169.078 239.905 181.986 234.738 195.386 234.857L293.498 234.857 293.498 352.198 57.5508 352.198C57.4335 352.198 57.4083 352.131 57.4838 352.056Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0662 0 0 1 75.8468 -79.6086)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.256 444.44C159.574 444.44 125.785 478.23 125.785 519.911 125.785 561.593 159.574 595.383 201.256 595.383 242.938 595.383 276.727 561.593 276.727 519.911 276.685 478.247 242.92 444.482 201.256 444.44ZM201.256 578.611C168.837 578.611 142.556 552.331 142.556 519.911 142.556 487.493 168.837 461.212 201.256 461.212 233.675 461.212 259.956 487.493 259.956 519.911 259.956 552.331 233.675 578.611 201.256 578.611Z",
    fill: "#FFFFFF",
    transform: "matrix(1.0662 0 0 1 75.8468 -79.6086)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar3);
export default __webpack_public_path__ + "static/media/car3.971e858393892b46665a5f3fa786db3d.svg";
export { ForwardRef as ReactComponent };